import React from 'react'

function SurgicalHistory() {
  return (
    <div>
      <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
  <div className="header h-[13%] bg-[#E0C1FF] flex items-center justify-center rounded p-2">
    <h1 className="font-bold text-normal text-[#2a0e41] mt-3">
      Surgical History
    </h1>
  </div>
  <div className="body h-[75%] overflow-y-auto scrollwidth bg-white border-t-2 border-t-[#9421F3]">
    <div className="items-center text-sm p-2 m-3 border rounded-md">
      <div className="font-semibold">Surgical History:
        <span className="font-medium text-gray-500"> Vasectomy (vas deferens)</span>
      </div>
      <div className="ml-auto font-medium mt-2 flex justify-start">
      <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
      </div>
    </div>
    <div className="items-center text-sm p-2 m-3 border rounded-md">
      <div className="font-semibold">Surgical History:
        <span className="font-medium text-gray-500"> Cardiac surgery (open heart)</span>
      </div>
      <div className="ml-auto font-medium mt-2 flex justify-start">
      <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
      </div>
    </div>
    <div className="items-center text-sm p-2 m-3 border rounded-md">
      <div className="font-semibold">Surgical History:
        <span className="font-medium text-gray-500"> Appendectomy (appendix removal)</span>
      </div>
      <div className="ml-auto font-medium mt-2 flex justify-start">
      <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
      </div>
    </div>
    <div className="items-center text-sm p-2 m-3 border rounded-md">
      <div className="font-semibold">Surgical History:
        <span className="font-medium text-gray-500"> Appendectomy (appendix removal)</span>
      </div>
      <div className="ml-auto font-medium mt-2 flex justify-start">
      <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
      </div>
    </div>
  </div>
  
  <div className="footer h-[44px] bg-[#E0C1FF] rounded"></div>
</div>

    </div>
  )
}

export default SurgicalHistory;
